export default __webpack_public_path__ + "static/media/small_van_purple.827c7641.svg";